import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { Button, message, notification } from 'antd';
import React from 'react';
import { Bridge } from "./bridge";
var useIntl = Bridge.useIntl;
var _pwa = {
    pwa: true
  },
  pwa = _pwa.pwa;
var isHttps = document.location.protocol === 'https:';
var clearCache = function clearCache() {
  // remove all caches
  if (window.caches) {
    caches.keys().then(function (keys) {
      keys.forEach(function (key) {
        caches.delete(key);
      });
    }).catch(function (e) {
      return console.log(e);
    });
  }
};

// if pwa is true
if (pwa) {
  // Notify user if offline now
  window.addEventListener('sw.offline', function () {
    message.warning(useIntl().formatMessage({
      id: 'app.pwa.offline'
    }));
  });

  // Pop up a prompt on the page asking the user if they want to use the latest version
  window.addEventListener('sw.updated', function (event) {
    var e = event;
    var reloadSW = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var worker;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // Check if there is sw whose state is waiting in ServiceWorkerRegistration
              // https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerRegistration
              worker = e.detail && e.detail.waiting;
              if (worker) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return", true);
            case 3:
              _context.next = 5;
              return new Promise(function (resolve, reject) {
                var channel = new MessageChannel();
                channel.port1.onmessage = function (msgEvent) {
                  if (msgEvent.data.error) {
                    reject(msgEvent.data.error);
                  } else {
                    resolve(msgEvent.data);
                  }
                };
                worker.postMessage({
                  type: 'skip-waiting'
                }, [channel.port2]);
              });
            case 5:
              clearCache();
              window.location.reload();
              return _context.abrupt("return", true);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function reloadSW() {
        return _ref.apply(this, arguments);
      };
    }();
    var key = "open".concat(Date.now());
    var btn = /*#__PURE__*/React.createElement(Button, {
      type: "primary",
      onClick: function onClick() {
        notification.destroy(key);
        reloadSW();
      }
    }, useIntl().formatMessage({
      id: 'app.pwa.serviceworker.updated.ok'
    }));
    notification.open({
      message: useIntl().formatMessage({
        id: 'app.pwa.serviceworker.updated'
      }),
      description: useIntl().formatMessage({
        id: 'app.pwa.serviceworker.updated.hint'
      }),
      btn: btn,
      key: key,
      onClose: function () {
        var _onClose = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", null);
              case 1:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function onClose() {
          return _onClose.apply(this, arguments);
        }
        return onClose;
      }()
    });
  });
} else if ('serviceWorker' in navigator && isHttps) {
  // unregister service worker
  var _navigator = navigator,
    serviceWorker = _navigator.serviceWorker;
  if (serviceWorker.getRegistrations) {
    serviceWorker.getRegistrations().then(function (sws) {
      sws.forEach(function (sw) {
        sw.unregister();
      });
    });
  }
  serviceWorker.getRegistration().then(function (sw) {
    if (sw) sw.unregister();
  });
  clearCache();
}